import { createSelector } from 'reselect'
import flocabularySearchPageSelector from 'redux/selectors/flocabulary/flocabulary_search_page_selector'

const flocabularyQuery = state => state.flocabulary.query
const flocabularyCategory = state => state.flocabulary.category
const flocabularyCategories = state => state.flocabulary.categories

const searchSelector = createSelector(
	[
		flocabularyQuery,
		flocabularyCategory,
		flocabularyCategories,
		flocabularySearchPageSelector,
	],
	(searchQuery, categorySelected, categories, searchPage) => {
		const isSubject = categories ? categories.some(category => category.page_name === categorySelected) : false
		return ({
			searchQuery,
			categorySelected: isSubject ? categories.find(category => category.page_name === categorySelected).name : categorySelected,
			isSubject,
			page: searchPage.page,
			hasMore: searchPage.hasMore,
			currentVideosIds: searchPage.currentVideosIds,
		})
	}
)

export default searchSelector
